
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.7","cy":"27","r":"10"}}),_c('path',{attrs:{"d":"M44.9 2.9C44.5 1.4 43.2.4 41.7.4c-.4 0-.9.1-1.3.3-1.5.6-2.3 2.4-1.9 4 1.1 4.1 1.7 8.3 1.8 12.5.1 2.3.1 4-.3 7.3-.3 2.4-.8 5.5-1.8 9.1s-4.3 6-8 6H17.7c-4.1 0-7.6-2.8-8.7-6.7-.8-3.3-1.3-6.2-1.5-8.5-.4-3.3-.4-4.9-.3-7.3.1-4.2.7-8.4 1.8-12.5.4-1.6-.4-3.4-1.9-4C6.6.5 6.2.4 5.7.4c-1.4 0-2.8 1-3.2 2.5C.6 10.2.1 17.7.8 25.1c.6 5.8 1.8 12 5.1 16.9 0 0 0 .1.1.1 3.4 4.9 5.3 10.7 5.3 16.7v12.8h24.8V58.9c0-6 1.9-11.8 5.3-16.7 0 0 0-.1.1-.1 3.3-4.9 4.4-11.1 5.1-16.9.8-7.5.2-15-1.7-22.3zM11.3 73.8l-.7 51c0 3.3 2.7 6 6 6s6-2.7 6-6v-41h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.7-51H11.3v.2z"}}),_c('g',[_c('path',{attrs:{"fill":"#FFF","d":"M22.8 54.1H20v-1.9h2.7v-2.6h1.9v2.6h2.7v1.9h-2.7v2.6h-1.9v-2.6z"}})])])
          )
        }
      }
    